The conflict result for the `postPosition` mutation.

The `idempotencyId` provided as part of `CreatePostingInstructionInput` while creating a position profile must be unique.
Providing the same `idempotencyId` will result in a conflict.
